

export const appRequestFormValidator = (formFields) => {
    const { ApplicationTypeID, FileName, FileType, ProofFile, ReasonID } = formFields;
    const newErrors = {};
    // Validate Password
    if (!ApplicationTypeID || ApplicationTypeID === "") {
        newErrors.ApplicationTypeID = "Application Type  is Required!";
    }

    if (!FileName || FileName.trim() === "") {
        newErrors.FileName = "File Name is Required!";
    }

    if (!FileType || FileType === "") {
        newErrors.FileType = "File Type is Required!";
    }
    if (!ProofFile || ProofFile === "") {
        newErrors.ProofFile = "Proof File is Required!";
    }

    if (!ReasonID || ReasonID === "") {
        newErrors.ReasonID = "Reason  is Required!";
    }

    return newErrors;
};
export const profileFormValidator = (formFields) => {
    const { BloodGroupID, DepartmentID, Email, PassportPhoto, StationID, NewMobileNumber, RegionID } = formFields;
    const newErrors = {};

    // Validate Password
    if (!BloodGroupID || BloodGroupID === "") {
        newErrors.BloodGroupID = "Blood Group is Required!";
    }
    if (!DepartmentID || DepartmentID === "") {
        newErrors.DepartmentID = "Department is Required!";
    }

    if (!Email || Email.trim() === "") {
        newErrors.Email = "Email is Required!";
    }

    if (!PassportPhoto || PassportPhoto.trim() === "") {
        newErrors.PassportPhoto = "Passport Photo is Required!";
    }
    if (!StationID || StationID === "") {
        newErrors.StationID = "Station  is Required!";
    }

    if (!RegionID || RegionID === "") {
        newErrors.RegionID = "Region is Required!";
    }
    // Validate NewMobileNumber
    // if (!NewMobileNumber || NewMobileNumber.trim() === "") {
    //     newErrors.NewMobileNumber = "NewMobileNumber is Required!";
    // } else if (!/^\d{10}$/.test(NewMobileNumber)) {
    //     newErrors.NewMobileNumber = "NewMobileNumber must be exactly 8 digits!";
    // }

    return newErrors;
};

export const loginFormValidator = (formFields) => {
    const { Password, CheckNumber } = formFields;
    const newErrors = {};

    // Validate Password
    if (!Password || Password.trim() === "") {
        newErrors.Password = "Password is Required!";
    } else if (Password.length < 8) {
        newErrors.Password = "Password not less 8 digits!";
    }

    // Validate CheckNumber
    if (!CheckNumber || CheckNumber.trim() === "") {
        newErrors.CheckNumber = "Check Number is Required!";
    } else if (!/^\d+$/.test(CheckNumber)) {
        newErrors.CheckNumber = "Check Number must contain only digits!";
    } else if (CheckNumber.length < 8) {
        newErrors.CheckNumber = "Check Number must be at least 8 digits!";
    } else if (CheckNumber.length > 12) {
        newErrors.CheckNumber = "Check Number must not be more than 12 digits!";
    }

    return newErrors;
};


export const resetFormValidator = (formFields) => {
    const { NationalID, CheckNumber } = formFields;
    const newErrors = {};

    // Validate NationalID
    if (!NationalID || NationalID.trim() === "") {
        newErrors.NationalID = "National ID is Required!";
    } else if (NationalID.length !== 20) {
        newErrors.NationalID = "National ID must be  20 characters!";
    } else if (!/^[a-zA-Z0-9]+$/.test(NationalID)) {
        newErrors.NationalID = "National ID must contain only letters and numbers!";
    }

    // Validate CheckNumber
    if (!CheckNumber || CheckNumber.trim() === "") {
        newErrors.CheckNumber = "Check Number is Required!";
    } else if (!/^\d+$/.test(CheckNumber)) {
        newErrors.CheckNumber = "Check Number must contain only digits!";
    } else if (CheckNumber.length < 8) {
        newErrors.CheckNumber = "Check Number must be at least 8 digits!";
    } else if (CheckNumber.length > 12) {
        newErrors.CheckNumber = "Check Number must not be more than 12 digits!";
    }


    return newErrors;
};


export const verifyFormValidator = (formFields) => {
    const { VerificationCode } = formFields;
    const newErrors = {};
    if (!VerificationCode || VerificationCode === "")
        newErrors.VerificationCode = "Verification Code is Required!";
    return newErrors;
};
// StartDate: "",
//     EndDate: "",
//     ReportType: "",
//     DocTypeID: ""
export const reportFormValidation = (formFields) => {
    const { ReportType, StartDate, EndDate, DocTypeID } = formFields;
    const newErrors = {};
    if (!ReportType || ReportType === "")
        newErrors.ReportType = "ReportType is Required!";
    if (!StartDate || StartDate === "")
        newErrors.StartDate = "Start Date is Required!";

    if (!EndDate || EndDate === "")
        newErrors.EndDate = "EndDate Date is Required!";

    if (ReportType === "get_etd_reports_by_doctype" && DocTypeID === "")
        newErrors.DocTypeID = "Document Type is Required!";
    return newErrors;
};


export const enquiryFormValidation = (formFields) => {
    const { ReportType, FirstName, Surname, ApplicationId } = formFields;
    const newErrors = {};
    if (!ReportType || ReportType === "" || ReportType == null)
        newErrors.ReportType = "Report Type is Required!";

    if (FirstName === "" && Surname === "" && ApplicationId === "")
        newErrors.Surname = "Select at least  two Fields!";

    if (FirstName == null && Surname == null && ApplicationId == null)
        newErrors.Surname = "Select at least  two Fields!";
    return newErrors;
};


export const passwordFormValidator = (formFields) => {
    const { Password, confirmPassword } = formFields;
    const newErrors = {};
    if (!confirmPassword || confirmPassword.trim() === "")
        newErrors.confirmPassword = "Confirm Password  is Required!";
    if (!Password || Password.trim() === "")
        newErrors.Password = "Password  is Required!";
    if (Password.trim() !== confirmPassword.trim())
        newErrors.Password = "Passwords do not match!";
    return newErrors;
};

// ─── Shared regex rules ────────────────────────────────────────────────────────
const RULES = {
    name:     /^[a-zA-Z\s\-']+$/,
    username: /^[a-zA-Z0-9@._\-]+$/,
    alphaNum: /^[a-zA-Z0-9\-\/]+$/,
    appId:    /^[a-zA-Z0-9\-]+$/,
    mobile:   /^\+?[\d\s\-]+$/,
    email:    /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    digits:   /^\d+$/,
};

const NO_SPECIAL_MSG = "Special characters are not allowed.";

// ─── Login ─────────────────────────────────────────────────────────────────────
export const loginSpecialCharValidator = (username) => {
    if (username && !RULES.username.test(username))
        return "Username must contain only letters, numbers, dots, hyphens, underscores, or @.";
    return null;
};

// ─── Add / Update User ─────────────────────────────────────────────────────────
export const addUserFormValidator = (formFields) => {
    const { PFNo, Email, MobileNo, Position } = formFields;
    const newErrors = {};

    if (!PFNo || PFNo.trim() === "") {
        newErrors.PFNo = "PF Number is required!";
    } else if (!RULES.alphaNum.test(PFNo.trim())) {
        newErrors.PFNo = "PF Number must contain only letters and numbers. " + NO_SPECIAL_MSG;
    }

    if (!Email || Email.trim() === "") {
        newErrors.Email = "Email Address is required!";
    } else if (!RULES.email.test(Email.trim())) {
        newErrors.Email = "Please enter a valid email address.";
    }

    if (!MobileNo || MobileNo.trim() === "") {
        newErrors.MobileNo = "Mobile Number is required!";
    } else if (!RULES.mobile.test(MobileNo.trim())) {
        newErrors.MobileNo = "Mobile Number must contain only digits. " + NO_SPECIAL_MSG;
    }

    if (Position && !RULES.name.test(Position.trim())) {
        newErrors.Position = "Position must contain only letters. " + NO_SPECIAL_MSG;
    }

    return newErrors;
};

export const updateUserFormValidator = (formFields) => {
    const { FirstName, MiddleName, LastName, email, phoneNumber, PfNumber } = formFields;
    const newErrors = {};

    if (!FirstName || FirstName.trim() === "") {
        newErrors.FirstName = "First Name is required!";
    } else if (!RULES.name.test(FirstName.trim())) {
        newErrors.FirstName = "First Name must contain only letters. " + NO_SPECIAL_MSG;
    }

    if (MiddleName && !RULES.name.test(MiddleName.trim())) {
        newErrors.MiddleName = "Middle Name must contain only letters. " + NO_SPECIAL_MSG;
    }

    if (!LastName || LastName.trim() === "") {
        newErrors.LastName = "Last Name is required!";
    } else if (!RULES.name.test(LastName.trim())) {
        newErrors.LastName = "Last Name must contain only letters. " + NO_SPECIAL_MSG;
    }

    if (PfNumber && !RULES.alphaNum.test(PfNumber.trim())) {
        newErrors.PfNumber = "PF Number must contain only letters and numbers. " + NO_SPECIAL_MSG;
    }

    if (email && !RULES.email.test(email.trim())) {
        newErrors.email = "Please enter a valid email address.";
    }

    if (phoneNumber && !RULES.mobile.test(phoneNumber.trim())) {
        newErrors.phoneNumber = "Phone Number must contain only digits. " + NO_SPECIAL_MSG;
    }

    return newErrors;
};

// ─── Unlock Document / Application search ─────────────────────────────────────
export const searchDocumentFormValidator = (DocumentNumber) => {
    const newErrors = {};
    if (!DocumentNumber || DocumentNumber.trim() === "") {
        newErrors.DocumentNumber = "Document Number is required!";
    } else if (!RULES.alphaNum.test(DocumentNumber.trim())) {
        newErrors.DocumentNumber = "Document Number must contain only letters, numbers, hyphens, or slashes. " + NO_SPECIAL_MSG;
    }
    return newErrors;
};

export const searchApplicationFormValidator = (applicationId) => {
    const newErrors = {};
    if (!applicationId || applicationId.trim() === "") {
        newErrors.applicationId = "Application Number is required!";
    } else if (!RULES.appId.test(applicationId.trim())) {
        newErrors.applicationId = "Application Number must contain only letters, numbers, or hyphens. " + NO_SPECIAL_MSG;
    }
    return newErrors;
};
